import React, { useEffect, useState } from 'react';

interface ISalesPerson {
  label: string;
  status: number;
}

interface CustomSearchProps {
    salesPeopleList: any[];
    onSalesManSelect: (value: any) => void;
    selectedSaleManName: string | undefined;
    clearValue: () => void;
    selectId?:boolean;
}

const CustomSearchHandler: React.FC<CustomSearchProps> = ({ salesPeopleList, onSalesManSelect, selectedSaleManName, clearValue, selectId }) => {
  const [inputValue, setInputValue] = useState(selectedSaleManName ? selectedSaleManName : '');
  const [showSuggestions, setShowSuggestions] = useState(false);


  useEffect(() => {
    if(selectId && selectedSaleManName ){
      

      const salesListStorage = localStorage.getItem('handlersList');
      const salesList = salesListStorage ? JSON.parse(salesListStorage) : [];
      const selected = salesList.find((salesMan: any) =>  salesMan.id == selectedSaleManName);
      // const selected = salesPeopleList.find((salesMan: any) =>  salesMan.value == selectedSaleManName);
      setInputValue(selected ? selected.fullName : '');
    }else{
      setInputValue(selectedSaleManName ? selectedSaleManName : '');
    }
  }, [])


  useEffect(() => {
    if(selectId){
      // console.log('selectedSaleManName', selectedSaleManName)
      // console.log('salesPeopleList', salesPeopleList)

      // const selected = salesPeopleList.find((salesMan: any) =>  salesMan.value == selectedSaleManName);
      // setInputValue(selected ? selected.label : '');
    }else{
      setInputValue(selectedSaleManName ? selectedSaleManName : '');
    }
  }, [selectedSaleManName])
  

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    console.log('handleInputChange value', value)

    // if(selectId){
    //   let selected = salesPeopleList.find((salesMan)=> salesMan && salesMan.label && salesMan.label == value);
    //   onSalesManSelect(selected.value);
    // }else{
    // }
    onSalesManSelect(value);
    setInputValue(value);
    setShowSuggestions(true);
  };

  const handleOptionSelect = (value: string) => {
    console.log('handleOptionSelect value', value)

    setInputValue(value);
    // if(selectId){
    //   console.log('salesPeopleList', salesPeopleList)
    //   let selected = salesPeopleList.find((salesMan)=> salesMan && salesMan.label && salesMan.label == value);
    //   onSalesManSelect(selected.value);
    // }else{
    // }
    onSalesManSelect(value);
    setShowSuggestions(false);
  };

  // Filter the list based on the user's input
  const filteredList = salesPeopleList.filter((o) =>
    o.label && o.label.toLowerCase().includes(inputValue)
  );


  const clear = () => {
    setInputValue('');
    clearValue()
  }

  return (
    <div style={{display:'flex', position: 'relative', width: '200px' }}>
      <input
        type="text"
        placeholder="מטפל/נציג"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setShowSuggestions(true)}
        onBlur={() => setShowSuggestions(false)}
      />

      {showSuggestions && filteredList.length > 0 && (
        <ul
          style={{
            listStyleType: 'none',
            margin: 0,
            padding: 0,
            border: '1px solid #ccc',
            position: 'absolute',
            top: '30px',
            width: '100%',
            background: '#fff',
            maxHeight: '500px',
            overflowY: 'auto',
            zIndex: 1000,
          }}
        >
          {filteredList.map((o, i) => (
            <li
              key={i}
              style={{
                padding: '8px',
                cursor: 'pointer',
                color: o.status === 1 ? 'red' : 'black',
              }}
              // Use onMouseDown to avoid losing focus before selection is set
              onMouseDown={() => handleOptionSelect(o.label)}
            >
              {o.label}
            </li>
          ))}
        </ul>
      )}


        <div className={`icon x-clear pointer ${inputValue === undefined || inputValue === '' ? 'hide' : ''}`} onClick={() => clear()}></div>

    </div>
  );
};

export default CustomSearchHandler;
